import { template as template_341e277618d549e89c7dd8e51867259d } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import ModuleTemplate from 'ember-route-template';
import type { Model } from '../routes/module';
const { stringify } = JSON;
export default ModuleTemplate(template_341e277618d549e89c7dd8e51867259d(`
  <div
    data-prerender-module
    data-prerender-module-id={{@model.id}}
    data-prerender-module-nonce={{@model.nonce}}
    data-prerender-module-status={{@model.status}}
  >
    <pre>{{stringify @model null 2}}</pre>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
